export const DOM_SETTINGS_RESET_STATE = 'DOM_SETTINGS_RESET_STATE';
export const DOM_SETTINGS_CURRENT_ITEM = 'DOM_SETTINGS_CURRENT_ITEM';

export const DOM_SETTINGS_REQUEST_LOADING = 'DOM_SETTINGS_REQUEST_LOADING';
export const DOM_SETTINGS_REQUEST_SUCCESS = 'DOM_SETTINGS_REQUEST_SUCCESS';
export const DOM_SETTINGS_REQUEST_FAILED = 'DOM_SETTINGS_REQUEST_FAILED';

export const DOM_SETTINGS_CURRENT_ACTION = 'DOM_SETTINGS_CURRENT_ACTION';
export const DOM_SETTINGS_RESET_ACTION = 'DOM_SETTINGS_RESET_ACTION';
